import { AlertTriangle } from 'lucide-react'
import { cn } from '@/lib/cn'
import { Button } from '@/components/ui/Button'

export interface ErrorStateProps {
  title?: string
  message: string
  onRetry?: () => void
  className?: string
}

export function ErrorState({
  title = 'Something went wrong',
  message,
  onRetry,
  className,
}: ErrorStateProps) {
  return (
    <div
      className={cn('flex flex-col items-center gap-2 px-6 py-10 text-center', className)}
      role="alert"
    >
      <AlertTriangle className="size-8 text-status-bad-ink" aria-hidden="true" />
      <p className="font-display text-body font-semibold text-ink">{title}</p>
      <p className="max-w-[42ch] text-small text-ink-2">{message}</p>
      {onRetry && (
        <Button variant="secondary" size="sm" className="mt-2" onClick={onRetry}>
          Try again
        </Button>
      )}
    </div>
  )
}
